import { getResponseData } from '@/helpers/mocks';
import { HttpResponse, delay } from 'msw';

const RESPONSE = {
  default: {
    response: {
      createdAt: 1747644092280,
      object: 'offerdisposalboardbydetails',
      success: true,
      data: [
        {
          period: 1,
          totalMonthlyReturn: 8809.140957913369,
          monthlyInterestReturn: 2823.916666666667,
        },
        {
          period: 2,
          totalMonthlyReturn: 8809.140957913369,
          monthlyInterestReturn: 2799.7761971256737,
        },
        {
          period: 3,
          totalMonthlyReturn: 8809.140957913369,
          monthlyInterestReturn: 2775.5382634933485,
        },
        {
          period: 4,
          totalMonthlyReturn: 8809.140957913369,
          monthlyInterestReturn: 2751.2024718650478,
        },
        {
          period: 5,
          totalMonthlyReturn: 8809.140957913369,
          monthlyInterestReturn: 2726.7684267424593,
        },
        {
          period: 6,
          totalMonthlyReturn: 8809.140957913369,
          monthlyInterestReturn: 2702.2357310271454,
        },
        {
          period: 7,
          totalMonthlyReturn: 8809.140957913369,
          monthlyInterestReturn: 2677.603986014063,
        },
        {
          period: 8,
          totalMonthlyReturn: 8809.140957913369,
          monthlyInterestReturn: 2652.8727913850544,
        },
        {
          period: 9,
          totalMonthlyReturn: 8809.140957913369,
          monthlyInterestReturn: 2628.0417452023166,
        },
        {
          period: 10,
          totalMonthlyReturn: 8809.140957913369,
          monthlyInterestReturn: 2603.110443901838,
        },
        {
          period: 11,
          totalMonthlyReturn: 8809.140957913369,
          monthlyInterestReturn: 2578.0784822868154,
        },
        {
          period: 12,
          totalMonthlyReturn: 8809.140957913369,
          monthlyInterestReturn: 2552.945453521038,
        },
        {
          period: 13,
          totalMonthlyReturn: 8809.140957913369,
          monthlyInterestReturn: 2527.710949122247,
        },
        {
          period: 14,
          totalMonthlyReturn: 8809.140957913369,
          monthlyInterestReturn: 2502.374558955469,
        },
        {
          period: 15,
          totalMonthlyReturn: 8809.140957913369,
          monthlyInterestReturn: 2476.935871226325,
        },
        {
          period: 16,
          totalMonthlyReturn: 8809.140957913369,
          monthlyInterestReturn: 2451.3944724743033,
        },
        {
          period: 17,
          totalMonthlyReturn: 8809.140957913369,
          monthlyInterestReturn: 2425.749947566015,
        },
        {
          period: 18,
          totalMonthlyReturn: 8809.140957913369,
          monthlyInterestReturn: 2400.0018796884165,
        },
        {
          period: 19,
          totalMonthlyReturn: 8809.140957913369,
          monthlyInterestReturn: 2374.149850342008,
        },
        {
          period: 20,
          totalMonthlyReturn: 8809.140957913369,
          monthlyInterestReturn: 2348.193439333998,
        },
        {
          period: 21,
          totalMonthlyReturn: 8809.140957913369,
          monthlyInterestReturn: 2322.1322247714515,
        },
        {
          period: 22,
          totalMonthlyReturn: 8809.140957913369,
          monthlyInterestReturn: 2295.9657830543965,
        },
        {
          period: 23,
          totalMonthlyReturn: 8809.140957913369,
          monthlyInterestReturn: 2269.6936888689143,
        },
        {
          period: 24,
          totalMonthlyReturn: 8809.140957913369,
          monthlyInterestReturn: 2243.315515180195,
        },
        {
          period: 25,
          totalMonthlyReturn: 8809.140957913369,
          monthlyInterestReturn: 2216.8308332255674,
        },
        {
          period: 26,
          totalMonthlyReturn: 8809.140957913369,
          monthlyInterestReturn: 2190.2392125074994,
        },
        {
          period: 27,
          totalMonthlyReturn: 8809.140957913369,
          monthlyInterestReturn: 2163.540220786573,
        },
        {
          period: 28,
          totalMonthlyReturn: 8809.140957913369,
          monthlyInterestReturn: 2136.733424074425,
        },
        {
          period: 29,
          totalMonthlyReturn: 8809.140957913369,
          monthlyInterestReturn: 2109.8183866266654,
        },
        {
          period: 30,
          totalMonthlyReturn: 8809.140957913369,
          monthlyInterestReturn: 2082.7946709357634,
        },
        {
          period: 31,
          totalMonthlyReturn: 8809.140957913369,
          monthlyInterestReturn: 2055.6618377239047,
        },
        {
          period: 32,
          totalMonthlyReturn: 8809.140957913369,
          monthlyInterestReturn: 2028.4194459358228,
        },
        {
          period: 33,
          totalMonthlyReturn: 8809.140957913369,
          monthlyInterestReturn: 2001.0670527315958,
        },
        {
          period: 34,
          totalMonthlyReturn: 8809.140957913369,
          monthlyInterestReturn: 1973.6042134794197,
        },
        {
          period: 35,
          totalMonthlyReturn: 8809.140957913369,
          monthlyInterestReturn: 1946.0304817483498,
        },
        {
          period: 36,
          totalMonthlyReturn: 8809.140957913369,
          monthlyInterestReturn: 1918.345409301011,
        },
        {
          period: 37,
          totalMonthlyReturn: 8809.140957913369,
          monthlyInterestReturn: 1890.5485460862815,
        },
        {
          period: 38,
          totalMonthlyReturn: 8809.140957913369,
          monthlyInterestReturn: 1862.6394402319456,
        },
        {
          period: 39,
          totalMonthlyReturn: 8809.140957913369,
          monthlyInterestReturn: 1834.6176380373167,
        },
        {
          period: 40,
          totalMonthlyReturn: 8809.140957913369,
          monthlyInterestReturn: 1806.4826839658303,
        },
        {
          period: 41,
          totalMonthlyReturn: 8809.140957913369,
          monthlyInterestReturn: 1778.2341206376077,
        },
        {
          period: 42,
          totalMonthlyReturn: 8809.140957913369,
          monthlyInterestReturn: 1749.8714888219865,
        },
        {
          period: 43,
          totalMonthlyReturn: 8809.140957913369,
          monthlyInterestReturn: 1721.3943274300268,
        },
        {
          period: 44,
          totalMonthlyReturn: 8809.140957913369,
          monthlyInterestReturn: 1692.802173506981,
        },
        {
          period: 45,
          totalMonthlyReturn: 8809.140957913369,
          monthlyInterestReturn: 1664.094562224736,
        },
        {
          period: 46,
          totalMonthlyReturn: 8809.140957913369,
          monthlyInterestReturn: 1635.2710268742244,
        },
        {
          period: 47,
          totalMonthlyReturn: 8809.140957913369,
          monthlyInterestReturn: 1606.3310988578046,
        },
        {
          period: 48,
          totalMonthlyReturn: 8809.140957913369,
          monthlyInterestReturn: 1577.2743076816107,
        },
        {
          period: 49,
          totalMonthlyReturn: 8809.140957913369,
          monthlyInterestReturn: 1548.1001809478705,
        },
        {
          period: 50,
          totalMonthlyReturn: 8809.140957913369,
          monthlyInterestReturn: 1518.808244347192,
        },
        {
          period: 51,
          totalMonthlyReturn: 8809.140957913369,
          monthlyInterestReturn: 1489.3980216508203,
        },
        {
          period: 52,
          totalMonthlyReturn: 8809.140957913369,
          monthlyInterestReturn: 1459.8690347028619,
        },
        {
          period: 53,
          totalMonthlyReturn: 8809.140957913369,
          monthlyInterestReturn: 1430.2208034124774,
        },
        {
          period: 54,
          totalMonthlyReturn: 8809.140957913369,
          monthlyInterestReturn: 1400.4528457460424,
        },
        {
          period: 55,
          totalMonthlyReturn: 8809.140957913369,
          monthlyInterestReturn: 1370.5646777192778,
        },
        {
          period: 56,
          totalMonthlyReturn: 8809.140957913369,
          monthlyInterestReturn: 1340.5558133893473,
        },
        {
          period: 57,
          totalMonthlyReturn: 8809.140957913369,
          monthlyInterestReturn: 1310.425764846922,
        },
        {
          period: 58,
          totalMonthlyReturn: 8809.140957913369,
          monthlyInterestReturn: 1280.1740422082153,
        },
        {
          period: 59,
          totalMonthlyReturn: 8809.140957913369,
          monthlyInterestReturn: 1249.8001536069828,
        },
        {
          period: 60,
          totalMonthlyReturn: 8809.140957913369,
          monthlyInterestReturn: 1219.3036051864906,
        },
        {
          period: 61,
          totalMonthlyReturn: 8809.140957913369,
          monthlyInterestReturn: 1188.6839010914528,
        },
        {
          period: 62,
          totalMonthlyReturn: 8809.140957913369,
          monthlyInterestReturn: 1157.9405434599335,
        },
        {
          period: 63,
          totalMonthlyReturn: 8809.140957913369,
          monthlyInterestReturn: 1127.0730324152173,
        },
        {
          period: 64,
          totalMonthlyReturn: 8809.140957913369,
          monthlyInterestReturn: 1096.0808660576483,
        },
        {
          period: 65,
          totalMonthlyReturn: 8809.140957913369,
          monthlyInterestReturn: 1064.9635404564324,
        },
        {
          period: 66,
          totalMonthlyReturn: 8809.140957913369,
          monthlyInterestReturn: 1033.7205496414103,
        },
        {
          period: 67,
          totalMonthlyReturn: 8809.140957913369,
          monthlyInterestReturn: 1002.351385594794,
        },
        {
          period: 68,
          totalMonthlyReturn: 8809.140957913369,
          monthlyInterestReturn: 970.8555382428715,
        },
        {
          period: 69,
          totalMonthlyReturn: 8809.140957913369,
          monthlyInterestReturn: 939.232495447678,
        },
        {
          period: 70,
          totalMonthlyReturn: 8809.140957913369,
          monthlyInterestReturn: 907.4817429986322,
        },
        {
          period: 71,
          totalMonthlyReturn: 8809.140957913369,
          monthlyInterestReturn: 875.6027646041385,
        },
        {
          period: 72,
          totalMonthlyReturn: 8809.140957913369,
          monthlyInterestReturn: 843.5950418831578,
        },
        {
          period: 73,
          totalMonthlyReturn: 8809.140957913369,
          monthlyInterestReturn: 811.4580543567403,
        },
        {
          period: 74,
          totalMonthlyReturn: 8809.140957913369,
          monthlyInterestReturn: 779.1912794395264,
        },
        {
          period: 75,
          totalMonthlyReturn: 8809.140957913369,
          monthlyInterestReturn: 746.7941924312136,
        },
        {
          period: 76,
          totalMonthlyReturn: 8809.140957913369,
          monthlyInterestReturn: 714.2662665079858,
        },
        {
          period: 77,
          totalMonthlyReturn: 8809.140957913369,
          monthlyInterestReturn: 681.6069727139118,
        },
        {
          period: 78,
          totalMonthlyReturn: 8809.140957913369,
          monthlyInterestReturn: 648.8157799523054,
        },
        {
          period: 79,
          totalMonthlyReturn: 8809.140957913369,
          monthlyInterestReturn: 615.8921549770527,
        },
        {
          period: 80,
          totalMonthlyReturn: 8809.140957913369,
          monthlyInterestReturn: 582.8355623839032,
        },
        {
          period: 81,
          totalMonthlyReturn: 8809.140957913369,
          monthlyInterestReturn: 549.645464601726,
        },
        {
          period: 82,
          totalMonthlyReturn: 8809.140957913369,
          monthlyInterestReturn: 516.3213218837302,
        },
        {
          period: 83,
          totalMonthlyReturn: 8809.140957913369,
          monthlyInterestReturn: 482.86259229865027,
        },
        {
          period: 84,
          totalMonthlyReturn: 8809.140957913369,
          monthlyInterestReturn: 449.2687317218948,
        },
        {
          period: 85,
          totalMonthlyReturn: 8809.140957913369,
          monthlyInterestReturn: 415.5391938266599,
        },
        {
          period: 86,
          totalMonthlyReturn: 8809.140957913369,
          monthlyInterestReturn: 381.6734300750069,
        },
        {
          period: 87,
          totalMonthlyReturn: 8809.140957913369,
          monthlyInterestReturn: 347.6708897089028,
        },
        {
          period: 88,
          totalMonthlyReturn: 8809.140957913369,
          monthlyInterestReturn: 313.53101974122546,
        },
        {
          period: 89,
          totalMonthlyReturn: 8809.140957913369,
          monthlyInterestReturn: 279.2532649467317,
        },
        {
          period: 90,
          totalMonthlyReturn: 8809.140957913369,
          monthlyInterestReturn: 244.8370678529888,
        },
        {
          period: 91,
          totalMonthlyReturn: 8809.140957913369,
          monthlyInterestReturn: 210.28186873126958,
        },
        {
          period: 92,
          totalMonthlyReturn: 8809.140957913369,
          monthlyInterestReturn: 175.5871055874101,
        },
        {
          period: 93,
          totalMonthlyReturn: 8809.140957913369,
          monthlyInterestReturn: 140.75221415263047,
        },
        {
          period: 94,
          totalMonthlyReturn: 8809.140957913369,
          monthlyInterestReturn: 105.77662787431854,
        },
        {
          period: 95,
          totalMonthlyReturn: 8809.140957913369,
          monthlyInterestReturn: 70.65977790677604,
        },
        {
          period: 96,
          totalMonthlyReturn: 8809.140957913369,
          monthlyInterestReturn: 35.40109310192718,
        },
      ],
    },
    error: {
      response: {
        createdAt: 1701115461239,
        object: 'login',
        success: false,
      },
      status: 500,
    },
  },
};

const disposalboardHandler = async () => {
  const { response, status } = getResponseData(RESPONSE);
  await delay(1000);
  return HttpResponse.json(response, status);
};

export {
  disposalboardHandler,
};
